import { HandleSubmitForm } from "../utils/HandleSubmitForm";
import { new_map } from "../modules/google-map";
import resolveConfig from "tailwindcss/resolveConfig";
import tailwind from "../../../tailwind.config";
const tailwindConfig = resolveConfig(tailwind);

export default () => {
    const siteHeaderEl = document.querySelector(".site-header");
    const headerNavEl = siteHeaderEl.querySelector(".site-header__nav");

    // Toggla menyn
    function toggleMenu() {
        siteHeaderEl.classList.toggle("site-header--menu-open");

        const hidden = headerNavEl.getAttribute("aria-hidden");
        headerNavEl.setAttribute(
            "aria-hidden",
            hidden === "true" ? "false" : "true"
        );
    }
    $(".nav-toggle").on("click", toggleMenu);
    $(".site-header__overlay").on("click", toggleMenu);

    /**
     * Toggles main navigation sub menu
     */
    document.querySelectorAll(".menu-item__icon").forEach(icon => {
        icon.addEventListener(
            "click",
            event => {
                $(event.target)
                    .next()
                    .slideToggle(200);
            },
            true
        );
    });

    /**
     * Remove inline display on desktop at resize
     */
    let resizeTimer;
    window.addEventListener("resize", () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            if (viewIsMoreThan(tailwindConfig.theme.screens.lg)) {
                document
                    .querySelectorAll(".site-header__nav .sub-menu")
                    .forEach(subMenu => {
                        subMenu.style.removeProperty("display");
                    });
            }
        }, 250);
    });

    function viewIsMoreThan(width) {
        return window.matchMedia(`(min-width: ${width})`).matches;
    }

    // Current page item öppnar menyn
    const menuItemWillOpen = $(".current_page_item").parent(".sub-menu");
    const menuAncestorWillOpen = $(".current-menu-ancestor > .sub-menu");
    const allMenuItems = $.merge(menuItemWillOpen, menuAncestorWillOpen);
    allMenuItems.each((index, item) => {
        item.classList.add("sub-menu--open");
    });

    // Validering
    // Defaults
    $.extend(jQuery.validator.messages, {
        required: "Det här fältet är obligatoriskt.",
        number: "Vänligen fyll i ett nummer.",
        email: "Vänligen fyll i en giltig e-postadress."
    });
    $.extend(jQuery.validator.defaults, {
        errorClass: "form--error text text--small no-margin",
        validClass: "form--valid text text--small no-margin"
    });

    /**
     * Search button in header
     */
    const searchToggle = document.querySelector(".toggle-header-search-form");
    const searchForm = document.querySelector(".header-search-form");
    const input = document.querySelector(".header-search-form__input");
    let wait = false;
    searchToggle.addEventListener("click", () => toggleSearchButton(true));
    input.addEventListener("focus", () => toggleSearchButton(true));
    input.addEventListener("blur", () => toggleSearchButton(false));

    function toggleSearchButton(focusIn) {
        if (wait) {
            return;
        }
        wait = true;
        searchForm.classList.remove("header-search-form--active");
        if (focusIn) {
            searchForm.classList.add("header-search-form--active");
            setTimeout(() => {
                input.select(); //search input
            }, 200);
        }

        // prevent dubble-trigger
        setTimeout(() => {
            wait = false;
        }, 200);
    }

    if ($(".contact-form").length > 0) {
        const contactForm = new HandleSubmitForm(".contact-form");
        contactForm.setActionName = "submit";
    }

    if ($(".newsletter-form").length > 0) {
        const newsletterForm = new HandleSubmitForm(".newsletter-form");
        newsletterForm.setActionName = "submit_newsletter";
    }

    /**
     *  AJAX-request
     */
    $(".loadmore-group").on("click", function() {
        const button = $(".loadmore");
        const group = $(".loadmore-group");
        const post = $(".current-post-amount");
        const buttonText = button.text();
        const data = {
            action: "loadmore",
            page: horizon.current_page,
            "query-type": button.data("query-type"),
            cat: button.data("cat-query")
        };

        const loopContainer = $(".loop-container");

        $.ajax({
            url: horizon.ajaxUrl,
            data: data,
            type: "POST",
            beforeSend: function(xhr) {
                button.text("Laddar...").prop("disable", true);
                group.addClass("loading");
            },
            success: function(response) {
                if (response) {
                    // insert posts
                    response.data.forEach(function(el) {
                        loopContainer.append(el);
                    });

                    // handle UI
                    button.text(buttonText).prop("disable", false);
                    group.removeClass("loading");

                    // update state
                    horizon.current_page++;

                    // update posts counter UI
                    const currentPosts =
                        horizon.current_page * horizon.posts_per_page;
                    post.text(
                        currentPosts >= horizon.found_posts
                            ? horizon.found_posts
                            : currentPosts
                    );

                    // remove button if no more posts
                    if (horizon.current_page == response.max_pages) {
                        group.remove();
                    }
                } else {
                    group.remove();
                }
            }
        });
    });

    // initializes the map
    $(".members-map__map").each(function() {
        new_map($(this));
    });

    /**
     * Open close accordion
     */
    const accordionComponents = document.querySelectorAll(".slide-component");
    accordionComponents.forEach(accordion => {
        accordion
            .querySelector(".slide-toggle")
            .addEventListener("click", event => {
                $(event.target)
                    .next()
                    .slideToggle();
            });
    });

    const openButtonMenus = document.querySelectorAll(".button-menu-trigger");
    openButtonMenus.forEach(button => {
        button.addEventListener(
            "click",
            event => {
                if (!event.target.classList.contains("button-menu")) {
                    return;
                }
                event.target.classList.toggle("button-menu--open");
                event.target.firstElementChild.classList.toggle(
                    "button-menu--open__dropdown"
                );
            },
            { capture: true }
        );
    });
};
